<!-- eslint-disable @angular-eslint/template/no-call-expression -->

<div class="flex flex-col gap-3">
  <div class="rounded-md border border-solid border-gray-300 bg-white p-3">
    <div class="mb-2 font-semibold opacity-90">Patient Information</div>
    <div class="grid grid-cols-2 gap-4">
      <div class="space-y-2">
        <div>
          <span class="font-medium">Name:</span>
          {{ claimData().patient?.details?.firstName }}
          {{ claimData().patient?.details?.surname }}
        </div>
        <div>
          <span class="font-medium">NHI:</span>
          {{ claimData().patient?.details?.nhi || 'Not provided' }}
        </div>
        <div>
          <span class="font-medium">DOB:</span>
          {{
            claimData().patient?.details?.dateOfBirth
              | moment
              | amDateFormat: dateFormat
          }}
        </div>
        <div>
          <span class="font-medium">Gender:</span>
          {{ claimData().patient?.details?.gender }}
        </div>
      </div>
      <div class="space-y-2">
        <div><span class="font-medium">Address:</span></div>
        <div class="ml-4 text-sm text-gray-600">
          {{ claimData().patient?.address?.line1 }}<br />
          {{ claimData().patient?.address?.suburb }},
          {{ claimData().patient?.address?.city }}<br />
          {{ claimData().patient?.address?.postCode }}
        </div>
      </div>
    </div>
  </div>

  <div class="rounded-md border border-solid border-gray-300 bg-white p-3">
    <div class="mb-2 font-semibold opacity-90">Injury Information</div>
    <div class="grid grid-cols-2 gap-4">
      <div class="space-y-2">
        <div>
          <span class="font-medium">Accident Date:</span>
          {{
            claimData().injury?.accidentDate | moment | amDateFormat: dateFormat
          }}
        </div>
        <div>
          <span class="font-medium">Cause:</span>
          {{ claimData().injury?.causeOfAccident }}
        </div>
        <div>
          <span class="font-medium">Work Related:</span>
          {{ claimData().injury?.workInjury === 'True' ? 'Yes' : 'No' }}
        </div>
      </div>
      <div class="space-y-2">
        <div>
          <span class="font-medium">Vehicle Involved:</span>
          {{ claimData().injury?.involvesVehicle === 'True' ? 'Yes' : 'No' }}
        </div>
        <div>
          <span class="font-medium">Sporting Injury:</span>
          {{ claimData().injury?.sportingInjury === 'True' ? 'Yes' : 'No' }}
        </div>
        <div *ngIf="claimData().injury?.injuryComments" class="text-sm">
          <span class="font-medium">Comments:</span>
          {{ claimData().injury?.injuryComments }}
        </div>
      </div>
    </div>
  </div>

  <div class="rounded-md border border-solid border-gray-300 bg-white p-3">
    <div class="mb-2 font-semibold opacity-90">Dental Information</div>
    <div class="grid grid-cols-2 gap-4">
      <div class="space-y-2">
        <div>
          <span class="font-medium">Oral Hygiene:</span>
          {{ claimData().dentalDiagnosis?.other?.oralHygiene }}
        </div>
        <div>
          <span class="font-medium">Caries Activity:</span>
          {{ claimData().dentalDiagnosis?.other?.cariesActivityInMouth }}
        </div>
        <div>
          <span class="font-medium">Periodontal Condition:</span>
          {{ claimData().dentalDiagnosis?.other?.periodontalCondition }}
        </div>
      </div>
      <div class="space-y-2">
        <div>
          <span class="font-medium">Radiographs Taken:</span>
          {{
            claimData().dentalDiagnosis?.other?.radiographsType === 'True'
              ? 'Yes'
              : 'No'
          }}
        </div>
        <div>
          <span class="font-medium">Photo Record:</span>
          {{
            claimData().dentalDiagnosis?.other?.photographicRecordOfInjury ===
            'True'
              ? 'Yes'
              : 'No'
          }}
        </div>
        @if (claimData().dentalDiagnosis?.teeth?.injuries?.length) {
          <div>
            <span class="font-medium">Affected Teeth:</span>
            <div class="mt-1 text-sm">
              @for (
                tooth of claimData().dentalDiagnosis?.teeth?.injuries;
                track tooth.toothNumber
              ) {
                <span class="mr-2 inline-block">
                  Tooth {{ tooth.toothNumber }}:
                  {{
                    tooth.injuryClassification | map: injuryClassificationLabel
                  }}
                </span>
              }
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</div>
